import { COMMUNITY_ROLES } from '@/constants/community-roles';

/**
 * The community roles a user effectively holds for access checks.
 *
 * The backend treats a board member as a community manager everywhere
 * (CommunityRoleMiddleware), and RoleGuard applies the same rule. The nav had no
 * equivalent, so a board member could open /units by URL but never saw the menu
 * item. Keep all three in agreement by routing nav checks through here.
 */
export function effectiveCommunityRoles(roles?: string[] | null): string[] {
  const held = roles ?? [];

  return held.includes(COMMUNITY_ROLES.BOARD_MEMBER) && !held.includes(COMMUNITY_ROLES.COMMUNITY_MANAGER)
    ? [...held, COMMUNITY_ROLES.COMMUNITY_MANAGER]
    : held;
}
